<script setup lang="ts">
const props = defineProps<{
  title: string;
  action: string;
  link: string;
}>();
</script>

<template>
  <div :class="$style.item">
    <div :class="$style.item__title">{{ props.title }}</div>
    <Button
      size="small"
      theme="secondary"
      :to="props.link"
      :class="$style.item__button"
    >
      {{ props.action }}
    </Button>
  </div>
</template>

<style module lang="scss">
.item {
  display: flex;
  flex-flow: row nowrap;
  max-width: 100%;
  flex-grow: 1;
  gap: var(--space-2-5x);
  align-items: center;

  &__title {
    @include text_body1;
    color: var(--color-black-1);
  }

  &__button {
    width: initial !important;
    // Перебитие приоритета от Button
    white-space: nowrap;
  }
}

@media (max-width: 479px) {
  .item {
    gap: var(--space-1x);
  }
}
</style>
